<ng-template #login let-modal>
  <div class="modal-header">
    <div class="modal-title fs-5">
      <button type="button" *ngIf="loginStep==='verify'" title="Back" class="btn btn-secondary-outline back-button" (click)="goToMobileEnterScreen()"></button>
      <span>LOG IN / SIGN UP</span>
    </div>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onModalClose(modal)" *ngIf="allowClosingPopup"></button>
  </div>
  <div class="modal-body text-center">
    <div *ngIf="isLoading" class="loader my-5"></div>
    <div *ngIf="loginStep==='phone' && !isLoading" class="container show">
      <div class="row mb-4 mt-4">
        <div class="col"><img class="logo-img-gray" src="{{logo}}"></div>
      </div>
      <div class="row">
        <div class="col">
          <h4>{{title}}</h4>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">{{loginText}}</div>
      </div>
      <div class="row mb-3" *ngIf="loginErrorMessage">
        <div class="col">
          <div class="alert alert-warning mb-0" role="alert">{{ loginErrorMessage }}</div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <form #f="ngForm" class="form-floating form-phone-number needs-validation" (keypress)="phoneKeyPress($event)" autocomplete="off" [formGroup]="phoneForm" novalidate (submit)="enterPhone()">
            <div class="input-group has-validation">
              <span class="input-group-text" (click)="country.open(countryCode)">
                <img [src]="flagUrl" class="flag">
                <span class="px-1">{{dialCode}}</span>
              </span>
              <div class="form-floating">
                <input #phone type="tel" name="phone" formControlName="PhoneNumber" class="form-control" id="phone" placeholder="Mobile Number" required autofocus (input)="phoneChange()" (change)="phoneChange()">
                <label for="phone">Mobile Number</label>
              </div>
              <div class="invalid-feedback">
                Please enter a phone number.
              </div>
            </div>

            <button type="submit" class="btn btn-secondary mt-4 w-100" [disabled]="submitted || !hasPhone()">
              <div *ngIf="submitted" class="spinner-border" role="status">
                <span class="visually-hidden">Submitting...</span>
              </div>
              <span *ngIf="!submitted">Confirm</span>
            </button>
          </form>
        </div>
      </div>
    </div>

    <div *ngIf="loginStep==='verify' && !isLoading" class="container">
      <div class="row mb-4 mt-4">
        <div class="col"><img class="logo-img-gray" src="{{logo}}"></div>
      </div>
      <div class="row">
        <div class="col">
          <h4>Confirm Log In</h4>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          We sent a {{ verificationCodeLength }}-digit confirmation code to {{formattedPhoneNumber()}}. Didn't receive the code? <a href="javascript:void(0)" (click)="resendCode()">Resend</a>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <form class="form-floating" autocomplete="off">
            <input
              #code
              type="text"
              inputmode="numeric"
              autocomplete="one-time-code"
              pattern="[0-9]*"
              class="form-control"
              id="codeValue"
              placeholder="Enter Code"
              [attr.maxlength]="verificationCodeLength"
              value=""
              (keypress)="codeKeyPress($event)"
              (input)="codeChange(code.value)"
            >
            <label for="codeValue">Enter Code</label>

            <button type="button" class="btn btn-secondary mt-4 w-100" [disabled]="submitted || !codeValue || codeValue.length !== verificationCodeLength" (click)="enterCode()">
              <div *ngIf="submitted" class="spinner-border" role="status">
                <span class="visually-hidden">Submitting...</span>
              </div>
              <span *ngIf="!submitted">Confirm</span>
            </button>
          </form>
        </div>
      </div>
    </div>

    <div *ngIf="loginStep==='register' && !isLoading" class="container">
      <form class="form-floating profileForm" (ngSubmit)="registerMember()" [formGroup]="profileForm" novalidate >
        <div class="row">
          <div class="col">
            <h4 *ngIf="!showGetStarted">{{title}}</h4>
            <h4 *ngIf="showGetStarted">Create your account</h4>
          </div>
        </div>
        <div class="row">
          <div class="col" *ngIf="!showGetStarted">
            {{loginText}}
          </div>
          <div class="col" *ngIf="showGetStarted">
            Please enter your contact information to create your account.
          </div>
        </div>
        <div class="row mb-4">
          <div class="col">
            <!-- <form class="form-floating"> -->
              <div class="container">
                <div class="row mt-3">
                  <div class="col">
                    <div class="form-floating">
                      <select #location id="LocationId" name="location" formControlName="LocationId" [ngClass]="{'form-select':true, 'is-invalid':isInvalid('LocationId')}" placeholder="LocationId" required>
                        <option selected disabled value="">Choose...</option>
                        <option *ngFor="let location of locations" [value]="location.Id">{{ location.Name }}</option>
                      </select>
                      <label class="form-label" for="Location">Location</label>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-6">
                    <div class="form-floating">
                      <input type="text" id="FirstName" name="firstName" formControlName="FirstName" [ngClass]="{'form-control':true, 'is-invalid':isInvalid('FirstName')}" placeholder="First Name" required>
                      <label class="form-label" for="FirstName">First Name</label>
                      <div *ngIf="isInvalid('FirstName')" class="invalid-feedback">
                        First name is required
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-floating">
                      <input type="text" id="LastName" name="lastName" formControlName="LastName" [ngClass]="{'form-control':true, 'is-invalid':isInvalid('LastName')}" placeholder="Last Name" required>
                      <label for="LastName">Last Name</label>
                      <div *ngIf="isInvalid('LastName')" class="invalid-feedback">
                        Last name is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-12">
                    <div class="form-floating">
                      <input type="email" id="Email" name="email" formControlName="Email" [ngClass]="{'form-control':true, 'is-invalid':isInvalid('Email')}" placeholder="Enter your email" required>
                      <label class="form-label" for="Email">Email</label>
                      <div *ngIf="isInvalid('Email')" class="invalid-feedback">
                        Email is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-6">
                    <df-datepicker
                      formControlName="BirthDate"
                      label="Date of Birth"
                      [min]="minDOB()"
                      [max]="maxDOB()"
                      [invalid]="isInvalid('BirthDate')"
                      inputId="BirthDate"
                    ></df-datepicker>
                    <div *ngIf="isInvalid('BirthDate')" class="invalid-feedback d-block">
                      Please enter a valid birth date (must be between {{minDOB()}} and {{maxDOB()}})
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-floating">
                      <select #gender id="Gender" name="gender" formControlName="Gender" [ngClass]="{'form-select':true, 'is-invalid':isInvalid('Gender')}" placeholder="Gender" required>
                        <option selected disabled value="">Choose...</option>
                        <option *ngFor="let gender of genderMap | keyvalue" [value]="gender.value">{{ gender.key }}</option>
                      </select>
                      <label class="form-label" for="Gender">Gender</label>
                      <div *ngIf="isInvalid('Gender')" class="invalid-feedback">
                        Gender is required
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Address fields: only show if collectAddressDuringSignup is true -->
                <ng-container *ngIf="facilityConfig.collectAddressDuringSignup">
                  <!-- Address Line 1 -->
                  <div class="row mt-3">
                    <div class="col-12">
                      <div class="form-floating">
                        <input type="text" id="AddressLine1" name="AddressLine1" formControlName="AddressLine1" [ngClass]="{'form-control':true, 'is-invalid':isInvalid('AddressLine1')}" placeholder="Address Line 1" required>
                        <label class="form-label" for="AddressLine1">Address Line 1</label>
                        <div *ngIf="isInvalid('AddressLine1')" class="invalid-feedback">
                          Address Line 1 is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Address Line 2 -->
                  <div class="row mt-3">
                    <div class="col-12">
                      <div class="form-floating">
                        <input type="text" id="AddressLine2" name="AddressLine2" formControlName="AddressLine2" [ngClass]="{'form-control':true, 'is-invalid':isInvalid('AddressLine2')}" placeholder="Address Line 2">
                        <label class="form-label" for="AddressLine2">Address Line 2</label>
                        <div *ngIf="isInvalid('AddressLine2')" class="invalid-feedback">
                          Address Line 2 is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <!-- City -->
                    <div class="col-6">
                      <div class="form-floating">
                        <input type="text" id="City" name="city" formControlName="City" [ngClass]="{'form-control':true, 'is-invalid':isInvalid('City')}" placeholder="City" required>
                        <label class="form-label" for="City">City</label>
                        <div *ngIf="isInvalid('City')" class="invalid-feedback">
                          City is required
                        </div>
                      </div>
                    </div>
                    <!-- State -->
                    <div class="col-6">
                      <div class="form-floating">
                        <input type="text" id="State" name="state" formControlName="State" [ngClass]="{'form-control':true, 'is-invalid':isInvalid('State')}" placeholder="State" required="">
                        <label class="form-label" for="State">State</label>
                        <div *ngIf="isInvalid('State')" class="invalid-feedback">
                          State is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-6">
                      <div class="form-floating">
                        <select #country id="Country" name="country" formControlName="Country" [ngClass]="{'form-select':true, 'is-invalid':isInvalid('Country')}" placeholder="Country" required>
                          <option selected disabled value="">Choose...</option>
                          <option *ngFor="let country of countries" [value]="country.code">{{ country.name }}</option>
                        </select>
                        <label class="form-label" for="Country">Country</label>
                        <div *ngIf="isInvalid('Country')" class="invalid-feedback">
                          Country is required
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-floating">
                        <input type="text" id="ZipCode" name="zipCode" type="number" maxlength="5" minlength="5" formControlName="ZipCode" [ngClass]="{'form-control':true, 'is-invalid':isInvalid('ZipCode')}" placeholder="Zip Code" required="">
                        <label class="form-label" for="ZipCode">Zip Code</label>
                        <div *ngIf="isInvalid('ZipCode')" class="invalid-feedback">
                          Zip code is required
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="!facilityConfig.collectAddressDuringSignup">
                  <div class="row mt-3">
                    <div class="col-6">
                      <div class="form-floating">
                        <input type="text" id="ZipCode" name="zipCode" type="number" maxlength="5" minlength="5" formControlName="ZipCode" [ngClass]="{'form-control':true, 'is-invalid':isInvalid('ZipCode')}" placeholder="Zip Code" required="">
                        <label class="form-label" for="ZipCode">Zip Code</label>
                        <div *ngIf="isInvalid('ZipCode')" class="invalid-feedback">
                          Zip code is required
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <!-- Email Notification -->
                <div class="row mt-3">
                  <div class="col-12">
                    <div class="form-group form-check text-left">
                      <input 
                          type="checkbox" 
                          id="EmailNotification" 
                          class="form-check-input" 
                          formControlName="EmailNotification"
                      />
                      <label for="EmailNotification" class="form-check-label">
                        Email me with news and updates
                      </label>
                    </div>
                  </div>
                </div>

                <!-- SMS Notification -->
                <div class="row mt-3">
                  <div class="col-12">
                    <div class="form-group form-check text-left">
                      <input 
                          type="checkbox" 
                          id="SmsNotification" 
                          class="form-check-input" 
                          formControlName="SmsNotification"
                      />
                      <label for="SmsNotification" class="form-check-label">
                        Text me with news and updates
                      </label>
                    </div>
                  </div>
                </div>
                <!-- Agree to Terms -->
                <div class="row mt-3">
                  <div class="col-12">
                    <div class="form-group form-check text-left">
                      <input 
                          type="checkbox" 
                          id="AgreeToTerms" 
                          class="form-check-input" 
                          formControlName="AgreeToTerms"
                          required
                      />
                      <label for="AgreeToTerms" class="form-check-label">
                          I agree to {{facilityConfig.name}}'s <a [href]="termsOfUseLink" target="_blank">Terms of Use</a> , <a [href]="privacyPolicyLink" target="_blank">Privacy Policy</a>, and <a [href]="safetyWaiverLink" target="_blank">Liability Release</a>
                      </label>
                      <div *ngIf="isInvalid('AgreeToTerms')" class="invalid-feedback">
                          You must agree to the terms and conditions, privacy policy and liability release agreement to proceed.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col">
            <button type="submit" class="btn btn-secondary mt-4 w-100" [disabled]="profileIsDisabled || submitted">
              <div *ngIf="submitted" class="spinner-border" role="status">
                <span class="visually-hidden">Submitting...</span>
              </div>
              <span *ngIf="!submitted">Confirm</span>
            </button>
          </div>
        </div>
      </form>
    </div>

    <div *ngIf="loginStep==='welcome' && !isLoading" class="container">
      <div class="row">
        <div class="col">
          <h4>Logging in...</h4>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <div class="loader"></div>
          <!-- <button type="button" class="btn btn-secondary mt-4 w-100" (click)="modal.dismiss('Success')">Close</button> -->
        </div>
      </div>
    </div>

    <div *ngIf="loginStep==='error' && !isLoading" class="container">
      <div class="row">
        <div class="col">
          <h4>An error has occured. Please try again.</h4>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <button type="button" class="btn btn-secondary mt-4 w-100" (click)="modal.dismiss('Error')">Close</button>
        </div>
      </div>
    </div>

    <div *ngIf="loginStep==='get-started' && !isLoading" class="container">
      <div class="row mb-4 mt-4">
        <div class="col"><img class="logo-img-gray" src="{{logo}}"></div>
      </div>
      <div class="row">
        <div class="col">
          <h4>{{title}}</h4>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          {{loginText}}
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <button type="button" class="btn btn-secondary mt-4 w-100" (click)="viewSchedule()">VIEW CLASS SCHEDULE</button>
        </div>
      </div>
    </div>

    <div *ngIf="loginStep==='agreement' && !isLoading" class="container show">
      <div class="row">
        <div class="col">
          <h4>{{title}}</h4>
        </div>
      </div>
      <div class="row mb-4 agreement-acceptance" *ngIf="memberDocs.length > 0">
        <div class="col">
          <form #f="ngForm" class="form-floating needs-validation" autocomplete="off" [formGroup]="agreementForm" novalidate (submit)="agreementForm.valid && submitAgreement()">
            <div class="row mt-3">
              <div class="col-12">
                <div class="form-group form-check text-left">
                  <div>
                        <input id="agreeToMembershipTerms" name="AgreeToTerms" type="checkbox" formControlName="AgreeToTerms" class="Checkbox-Input" (change)="onAgreementAcceptanceChange($event)" />
                        I acknowledge and consent to this 
                        <ul>
                            <li *ngFor="let doc of memberDocs; let i = index">
                                <a href="javascript:void(0)" (click)="openDocumentPreview(doc)">{{doc.Document?.Name}}</a><span *ngIf="i < memberDocs.length - 1">, </span>
                            </li>
                        </ul>
                    </div>
                </div>
              </div>
            </div>

            <button type="submit" class="btn btn-secondary mt-4 w-100" [disabled]="submitted || agreementIsDisabled">
              <div *ngIf="submitted" class="spinner-border" role="status">
                <span class="visually-hidden">Submitting...</span>
              </div>
              <span *ngIf="!submitted">Confirm</span>
            </button>
          </form>
        </div>
      </div>
    </div>

  </div>
  <!-- <div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="modal.close('Save click')">Close</button>
    <button type="button" class="btn btn-primary">Login</button>
  </div> -->

  <df-country-select #country (select)="changeCountry($event)"></df-country-select>
</ng-template>